<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="serverError === null">
  <div class="rounded-table-wrapper rounded-table-tight table-responsive"
       #notesTableWrapper>
    <table class="table table-12px">

      <thead>
      <tr class="position-relative">
        <th scope="col" colspan="99" class="text-primary p-0" style="font-size: 16px;">
          <div style="padding-left: 12px; padding-right: 12px; position: sticky; left: 0;"
               #notesTableTitleContainer>
            <div class="d-inline-block" style="margin-top: 13px;">
              <span>Event Notes</span>
            </div>
            <div class="float-right" style="margin-top: 8px; margin-bottom: 8px;">
              <button (click)="openAddNoteModal()"
                      class="btn btn-sm btn-outline-primary"
                      style="font-size: 12px; line-height: 12px;">
                Add Note
              </button>
            </div>
          </div>
        </th>
      </tr>
      <tr>
        <th scope="col">Date Added</th>
        <th scope="col">Note Title</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingNotes">
      <tr *ngFor="let note of notesList.results">

        <td>{{ dateStringFromISO8601(note.created_at) }}</td>

        <td>{{ note.title }}</td>

        <td class="table-12px-button-cell">
          <div class="text-right" ngPreserveWhitespaces>
            <button (click)="openEditNoteModal(note)"
                    class="btn btn-sm btn-outline-primary table-12px-button">
              View
            </button>
          </div>
        </td>

      </tr>

      <tr *ngIf="notesList.count === 0">
        <td colspan="99">
          No notes
        </td>
      </tr>

      </tbody>

      <tbody *ngIf="loadingNotes">
      <tr>
        <td colspan="99">Loading...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeEventNotesSubList" (change)="pageNumber = 1">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous"
                    [disabled]="pageNumber <= 1"
                    (click)="pageNumber = pageNumber - 1">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link"
                    (click)="pageNumber = pageNumber - 2">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link"
                    (click)="pageNumber = pageNumber - 1">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link"
                    (click)="pageNumber = pageNumber + 1">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link"
                    (click)="pageNumber = pageNumber + 2">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next"
                    [disabled]="pageNumber >= lastPageNumber()"
                    (click)="pageNumber = pageNumber + 1">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
